import {
  ApiResponse,
  CardDetailSettingResponse,
  CardToggleSetting,
  TankInformationResponse,
} from '../../types/apiResponse/tankInfoSettingTypes'
import { getData } from '../../utils'

/**
 * @deprecated Use getTankInformation(tankId) instead - endpoint changed to /tank/{tank_id}/tank_information
 */
export const getTankInfoCardToggleSetting = async () => {
  console.warn('getTankInfoCardToggleSetting is deprecated: use getTankInformation(tankId) instead')
  return {} as CardToggleSetting
}

/**
 * @deprecated Use getTankInformation(tankId) instead - endpoint changed to /tank/{tank_id}/tank_information
 */
export const getTankInfoCardDetail = async (_cardNames: string[]) => {
  console.warn('getTankInfoCardDetail is deprecated: use getTankInformation(tankId) instead')
  return [] as CardDetailSettingResponse[]
}

/**
 * Fetches tank information including tank card, water card, and school data
 *
 * Backend endpoint: GET /tank/{tank_id}/tank_information
 * Note: Response is auto-unwrapped by axios interceptor
 */
export const getTankInformation = async (tankId: string): Promise<TankInformationResponse> => {
  const response = await getData<TankInformationResponse>(`tank/${tankId}/tank_information`)
  return response
}
